import { render, staticRenderFns } from "./ChildUpsertRole.vue?vue&type=template&id=128e8abe&"
import script from "./ChildUpsertRole.vue?vue&type=script&lang=js&"
export * from "./ChildUpsertRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports